<template>
    <div class="discuss-second">
        <div class="discuss-second-title-bar">
            <!-- 1. 标题部分 -->
            <title-bar
                v-bind:titleData="titleData"
                v-bind:backFunc="clickBack"
                v-bind:createFunc="clickCreateDiscuss">
            </title-bar>
            <!-- 2. 列表部分 -->
            <div class="layout-sub-ymd-title" v-if="secondLunpanList.length > 0">
                <div class="layout-sub-ymd-title-box dsp-flex">
                    <div class="ymd-title-box-left"></div>
                    <div class="ymd-title-box">
                        <div class="ymd-title-box-box" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
                            <span class="title-span"><span v-for="string in stringArr">{{string}}</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="discuss-second-list" v-if="secondLunpanList.length > 0">
            <discuss-second-virtual-list></discuss-second-virtual-list>
        </div>
        <!-- 4.1 空数据组件 -->
        <no-data v-else
            v-bind:noteText="'记录空空如也~'"
            v-bind:showButton="true"
            v-bind:buttonText="'马上新建'"
            v-bind:buttonFunc="clickCreateDiscuss">
        </no-data>

        <router-view></router-view>
    </div>
</template>

<script>
import NoData from '../../components/common/NoData.vue'
import TitleBar from '../../components/TitleBar.vue'
import DiscussSecondVirtualList from '../../layouts/discuss/DiscussSecondVirtualList.vue';
export default {
    name: 'DiscussSecond',
    components: { NoData, TitleBar, DiscussSecondVirtualList },
    computed: {
        secondLunpanTab() {
            return this.$store.state.discuss.secondLunpanTab;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        secondLunpanList() {
            return this.$store.state.discuss.secondLunpanList;
        },
    },
    data() {
        return {
            curDataList: [],
            stringArr: ['年', '月', '日', '时'],
            titleData: { 'titleText': '', 'showCancel': false, titleCreate: '新建'},
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initData();
        }, 20);
    },
    methods: {
        initData() {
            var me = this,
                title = this.secondLunpanTab == 1 ? '已保存论盘记录' : '我参与的论盘';
            this.$set(this.titleData, 'titleText', title);
            if(this.secondLunpanTab == 1) {
                this.$store.dispatch('discuss/initMySavedLunPanList', {
                    cb: function() {
                        setTimeout(() => {
                            me.$bus.emit('updateDiscussSecondListDom');
                        }, 100);
                    }
                });
            }else if(this.secondLunpanTab == 2) {
                this.$store.dispatch('discuss/initMyJoinedLunPanList', {
                    cb: function() {
                        setTimeout(() => {
                            me.$bus.emit('updateDiscussSecondListDom');
                        }, 100);
                    }
                });
            }
        },
        clickBack() {
            this.$router.replace('/discussmain');
        },
        clickCreateDiscuss() {
            this.$store.dispatch('allrecord/resetRecordData');
            this.$store.state.chooserecord.chooseFromPage = 'discusssecond';
            this.$store.state.chooserecord.chooseRecordType = 'single';
            this.$router.replace('/discusssecond/chooserecord');
        }
    }
}
</script>